export default "__VITE_ASSET__BtqXdCJm__"